// Full config:  https://github.com/axios/axios#request-config
/* eslint-disable */
import Vue from 'vue';
import axios from "axios";
import store from '../store';

const baseConfig = {
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60 * 20000,
};

const _axiosInstance = axios.create(baseConfig);

_axiosInstance.interceptors.request.use(
  (config) => {
    const { common } = config.headers;
    if (store.getters.getEmail && store.getters.getToken) {
      common.USER_EMAIL = store.getters.getEmail;
      common.USER_TOKEN = store.getters.getToken;
      common['Cache-Control'] = 'no-cache';
    }
    return config;
  },
  (error) => Promise.reject(error)
);

_axiosInstance.interceptors.response.use(
  (response) => {
    if (response.headers.token) {
      store.dispatch('updateToken', response.headers.token);
    }
    return response;
  },
  (error) => {
    store.dispatch('handleError', error);
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue, options) {
  Vue.axios = _axiosInstance;
  window.axios = _axiosInstance;
  Object.defineProperties(Vue.prototype, {
    $axios: {
      get() {
        return _axiosInstance;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
